type AppState = {
  scaActivation: {
    procedureId: string | undefined;
  };
};

export const getProcedureId = (state: AppState) => {
  return state.scaActivation.procedureId;
};
